import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
import ReduxRecord from './reduxRecord';
export var QtiImport = /*#__PURE__*/function (_ReduxRecord) {
  function QtiImport() {
    _classCallCheck(this, QtiImport);
    return _callSuper(this, QtiImport, arguments);
  }
  _inherits(QtiImport, _ReduxRecord);
  return _createClass(QtiImport, [{
    key: "progressNumber",
    value: function progressNumber() {
      switch (this.status) {
        case 'importing':
          return this.progress;
        case 'completed':
          return 1.0;
        default:
          // Scheduled, failed
          return 0.0;
      }
    }
  }, {
    key: "isImporting",
    value: function isImporting() {
      return this.status === 'importing';
    }
  }]);
}(ReduxRecord({
  id: 0,
  quizId: null,
  status: null,
  url: null,
  message: null,
  progress: 0.0
}));
export default QtiImport;